// extracted by mini-css-extract-plugin
export default {"book":"ListAdvertising_book__ULvb4"};